var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],class:_vm.className,style:(_vm.imgStyle),attrs:{"title":_vm.title,"alt":_vm.alt,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }